<template>
  <div class="lot-bids-list">

    <div
      v-for="item in bidsListProp"
      :class="['row-bid', { 'current-user': item.belongs_to_user }]"
      :key="item.user_name"
    >
      <img :src="item.avatar_path" class="user-avatar" alt="avatar">

      <div class="bidder-name">
        {{ getUserName(item) }}

        <div v-if="isAdmin || item.belongs_to_user" class="small-date">
          (
          <formatted-date
            :utc-date="item.utc_date"
            moment-js-format="MMM DD, LT"
          ></formatted-date>
         )
        </div>

        <div v-else>
          <formatted-date
            :utc-date="item.utc_date"
            moment-js-format="MMM DD, LT"
          ></formatted-date>
        </div>

      </div>
      <div class="date">
        {{ item.bids_count }}
      </div>
      <div class="bid">
        {{ format_currency(item.highest_bid) }}
      </div>
    </div>

  </div>
</template>

<script lang="ts" setup>
import { defineProps } from "vue";
import { useAuctionStore } from "@/stores/AuctionStore";
import { format_currency } from "@/utils/currencies";
import { trans } from "@/utils/trans";
import { IBidsListItem } from "@/models";
import FormattedDate from "@/components/_partials/FormattedDate.vue";

const props = defineProps<{
  bidsListProp: Array<IBidsListItem>;
  isAdmin: boolean;
}>();

const auctionStore = useAuctionStore();

const getUserName = (item: IBidsListItem) => {
  return item.belongs_to_user
    ? trans('live.catalog.lot_details_popup.your_bid')
    : item.user_name;
};
</script>

<style lang="scss" scoped>
    .lot-bids-list {
        width: 100%;
        display: flex;
        flex-direction: column;
        font-size: 16px;
        font-weight: 500;
        font-family: 'Montserrat', sans-serif;
    }

    .row-bid {
        display: flex;
        align-items: center;
        border-bottom: 1px solid #e4e4e4;
        padding: 10px 0;
        gap: 12px;
        color: #2A3644;


        &.current-user {
            color: #00CC99;
        }

        .formatted-date-wrapper {
            justify-content: center;
        }
    }

    .user-avatar {
        width: 35px;
    }

    .bidder-name {
        display: flex;
        align-items: center;
        flex: 1;
        gap: 5px;

        .small-date {
            display: flex;
            font-size: 14px;
            align-items: center;
        }
    }

    .bid {
        text-align: center;
        width: 15%;
    }

    .date {
        width: 30%;
        text-align: center;
    }

    @media (max-width: 764px) {
        .bidder-name {
            flex-direction: column;
            align-items: flex-start;
        }
    }

    @media (max-width: 420px) {
        .lot-bids-list {
            font-size: 14px;
        }
        .date {
            width: 20%;
        }
        .row-bid {
            gap: 8px;
        }
    }

    @media (max-width: 360px) {
        .row-bid {
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;
        }
    }
</style>
